import React from 'react';

interface SafeIconProps {
  icon: any;
  className?: string;
  size?: number | string;
}

const SafeIcon: React.FC<SafeIconProps> = ({ icon: Icon, className, size }) => {
  if (!Icon) return null;
  return <Icon className={className} size={size} />;
};

export default SafeIcon;